<div id="home">
  <header>
    <div class="container">
      <div class="d-flex align-items-center">
        <div class="logo">
          <div class="hide-on-fixed">
            <img
              src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/logo-hifpt-v80.png"
              alt=""
              width="auto"
              height="auto"
            />
          </div>
          <div class="show-on-fixed">
            <img
              src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/logo-hifpt-fixed.png"
              alt=""
              width="auto"
              height="auto"
            />
          </div>
        </div>
        <a id="open-menu">
          <img
            src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/open-menu.png"
            alt=""
            width="auto"
            height="auto"
          />
        </a>
        <nav aria-label="menu" class="menu">
          <ul>
            <li>
              <a class="scroll-to" data-target="banner">Trang chủ</a>
            </li>
            <li>
              <a class="scroll-to" data-target="section-1">Giới thiệu</a>
            </li>
            <li>
              <a class="scroll-to" data-target="section-4"> Tính năng</a>
            </li>

            <li>
              <a class="scroll-to" data-target="section-6"> Tải ứng dụng</a>
            </li>
          </ul>
        </nav>
        <nav aria-label="mobile" class="menu-mobile">
          <div class="bg"></div>
          <div class="menu-wrapper">
            <div class="top-section">
              <a href="" id="close-menu">
                <img
                  src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/cancel-close-2.png"
                  alt=""
                  width="auto"
                  height="auto"
                />
              </a>
            </div>
            <div class="logo">
              <div>
                <img
                  src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/logo-80-blue.png"
                  alt=""
                  width="auto"
                  height="auto"
                />
              </div>
            </div>
            <ul>
              <li>
                <a class="scroll-to" data-target="banner">Trang chủ</a>
              </li>
              <li>
                <a class="scroll-to" data-target="section-1">Giới thiệu</a>
              </li>
              <li>
                <a class="scroll-to" data-target="section-4"> Tính năng</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </header>
  <div class="banner" id="banner">
    <div class="container h-100">
      <div class="row h-100">
        <div class="col-md-5 col-xs-12">
          <div class="content-banner">
            <h1>
              <div>Internet FPT</div>
              <div class="d-flex">
                <span>và hơn thế</span>
              </div>
            </h1>
            <div class="description hide-on-mobile">
              Hi FPT là Ứng dụng được phát triển bởi FPT Telecom, cung cấp<br />
              những tính năng phục vụ khách hàng trong việc quản lý toàn
              trình<br />
              các dịch vụ Internet.
            </div>
            <div class="description show-on-mobile">
              Hi FPT là Ứng dụng được phát triển bởi FPT Telecom, cung cấp những
              tính năng phục vụ khách hàng trong việc quản lý toàn trình các
              dịch vụ Internet.
            </div>
            <div class="download">
              <div class="qr-code">
                <img
                  src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/qr-code-text.png"
                  alt=""
                  width="auto"
                  height="auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <section id="section-1" class="goscroll" data-anitype="animate__fadeInUp">
    <div class="container">
      <div class="section-wrapper">
        <h2 class="section-title text-center">
          Số người cài đặt ứng dụng Hi FPT
        </h2>
        <div class="number-wrapper">
          <div class="number">9</div>
          <div class="dot"></div>
          <div class="number">5</div>
          <div class="number">6</div>
          <div class="number">7</div>
          <div class="dot"></div>
          <div class="number">0</div>
          <div class="number">7</div>
          <div class="number">9</div>
        </div>
        <div class="icon-box">
          <div class="row goscroll" data-anitype="animate__fadeInUp">
            <div class="col-md-4 col-xs-12">
              <div class="wrapper d-flex align-items-center">
                <div class="icon">
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/icon-download.png"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </div>
                <div class="content">
                  <div class="item-title">9 TRIỆU +</div>
                  <div class="des">Lượt tải xuống ứng dụng</div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-xs-12">
              <div class="wrapper d-flex align-items-center">
                <div class="icon">
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/icon-user.png"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </div>
                <div class="content">
                  <div class="item-title">1.3 TRIỆU +</div>
                  <div class="des">Người dùng truy cập hàng tháng</div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-xs-12">
              <div class="wrapper d-flex align-items-center">
                <div class="icon">
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/icon-interaction.png"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </div>
                <div class="content">
                  <div class="item-title">7 TRIỆU +</div>
                  <div class="des">Lượt tương tác trên ứng dụng mỗi tháng</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="section-3">
    <div class="container">
      <div class="section-wrapper">
        <div class="row">
          <div
            class="col-md-5 col-xs-12 goscroll"
            data-anitype="animate__fadeInLeft"
          >
            <div class="col-wrapper">
              <h2 class="section-title">
                <div class="hide-on-mobile">
                  Hỗ trợ sự cố <span>nhanh nhất</span> <br />trên ứng dụng Hi
                  FPT
                </div>
                <div class="show-on-mobile">
                  Hỗ trợ sự cố <br />
                  <span>nhanh nhất</span> <br />trên ứng dụng Hi FPT
                </div>
              </h2>
              <ul class="list-item">
                <li>
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/tick-circle.svg"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                  <div class="content">
                    <span>Chủ động</span> báo cáo sự cố 24/7
                  </div>
                </li>
                <li>
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/tick-circle.svg"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                  <div class="content">
                    Thao tác nhanh,<span>không tốn phí</span>
                  </div>
                </li>
                <li>
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/tick-circle.svg"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                  <div class="content">
                    <span>Chủ động</span> theo dõi tiến trình xử lý
                  </div>
                </li>
                <li>
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/tick-circle.svg"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                  <div class="content">
                    <span>100% đúng hẹn</span> hỗ trợ tại nhà
                  </div>
                </li>
              </ul>
              <a (click)="moveToYCHT()" class="link button-ycht" target="_blank"
                >Trải nghiệm ngay</a
              >
            </div>
          </div>
          <div
            class="col-md-7 col-xs-12 goscroll"
            data-anitype="animate__fadeInRight"
          >
            <div class="img">
              <img
                src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/image-sc-3-80.png"
                alt=""
                width="auto"
                height="auto"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="section-4">
    <div class="container">
      <h2
        class="section-title text-center goscroll"
        data-anitype="animate__fadeInUp"
      >
        <div class="hide-on-mobile">
          <span>Nâng cấp trải nghiệm</span> với những tính năng
          <span>nổi bật</span>
        </div>
        <div class="show-on-mobile">
          <span>Nâng cấp trải nghiệm</span><br />
          với những tính năng<br />
          <span>nổi bật</span>
        </div>
      </h2>
      <div
        class="row goscroll justify-content-center"
        data-anitype="animate__fadeInUp"
      >
        <div class="col-md-4 col-xs-12">
          <div class="col-wrapper">
            <div class="img">
              <img
                src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/img_sc_4_1.png"
                alt=""
                width="auto"
                height="auto"
              />
            </div>
            <div class="content">
              <h3 class="title">
                Quản lý Modem Wi-Fi từ xa, đảm bảo an toàn Internet
              </h3>
              <div class="description">
                <ul>
                  <li>Kiểm soát người lạ truy cập</li>
                  <li>Ngăn chặn trang web độc hại</li>
                  <li>Điều khiển thiết bị từ xa</li>
                  <li>Quản lý thời gian sử dụng</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xs-12">
          <div class="col-wrapper">
            <div class="img">
              <img
                src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/img_sc_4_2_80.png"
                alt=""
                width="auto"
                height="auto"
              />
            </div>
            <div class="content">
              <h3 class="title">Kích hoạt nhanh chóng, quản lý thuận tiện</h3>
              <div class="description">
                <ul>
                  <li>Tải và đăng nhập chỉ từ 1 phút</li>
                  <li>Cập nhật đầy đủ thông tin hợp đồng</li>
                  <li>Quản lý toàn bộ thiết bị mạng gia đình nhanh tiện</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="section-5">
    <div class="container">
      <h2 class="section-title text-center">
        <div class="hide-on-mobile">
          Chủ động thực hiện <span>mọi giao dịch</span> ngay tại nhà
        </div>
        <div class="show-on-mobile">
          Chủ động thực hiện <br /><span>mọi giao dịch</span> <br />ngay tại nhà
        </div>
      </h2>
      <div class="hide-on-mobile">
        <div class="row">
          <div class="col-3 goscroll" data-anitype="animate__fadeInLeft">
            <div class="col-wrapper text-right">
              <div class="item">
                <div class="icon">
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/icon-contract.png"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </div>
                <div class="text">
                  Ký hợp đồng dịch vụ và xác nhận biên bản nghiệm thu ngay trên
                  App
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/icon-payment-sc-5.png"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </div>
                <div class="text">
                  Thanh toán an toàn, theo dõi hóa đơn và lịch sử thanh toán
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 goscroll" data-anitype="animate__fadeIn">
            <div class="img">
              <div class="line-1 line"></div>
              <div class="line-2 line"></div>
              <div class="line-3 line"></div>
              <div class="line-4 line"></div>
              <div class="line-5 line"></div>
              <img
                src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/phone-sc-5-80-1.png"
                alt=""
                width="auto"
                height="auto"
              />
            </div>
          </div>
          <div class="col-3 goscroll" data-anitype="animate__fadeInRight">
            <div class="col-wrapper">
              <div class="item">
                <div class="icon">
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/icon-gift-sc-5.png"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </div>
                <div class="text">
                  Kho quà đa dạng, đổi quà Khách hàng thân thiết nhanh chóng
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/icon-global.png"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </div>
                <div class="text">100% toàn trình giao dịch Online</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="show-on-mobile">
        <div class="row">
          <div class="col-12 goscroll" data-anitype="animate__fadeIn">
            <div class="img">
              <div class="line-1 line"></div>
              <div class="line-2 line"></div>
              <div class="line-3 line"></div>
              <div class="line-4 line"></div>
              <div class="line-5 line"></div>
              <img
                src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/phone-sc-5-80.png"
                alt=""
                width="auto"
                height="auto"
              />
            </div>
          </div>
          <div class="col-12 goscroll" data-anitype="animate__fadeInLeft">
            <div class="col-wrapper">
              <div class="item">
                <div class="icon">
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/icon-contract.png"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </div>
                <div class="text">
                  Ký hợp đồng dịch vụ và xác nhận biên bản nghiệm thu ngay trên
                  App
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/icon-payment-sc-5.png"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </div>
                <div class="text">
                  Thanh toán an toàn, theo dõi hóa đơn và lịch sử thanh toán
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/icon-gift-sc-5.png"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </div>
                <div class="text">
                  Kho quà đa dạng, đổi quà Khách hàng thân thiết nhanh chóng
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/icon-global.png"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </div>
                <div class="text">100% toàn trình giao dịch Online</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="section-6">
    <div class="container">
      <div class="row align-items-center">
        <div
          class="col-md-6 col-xs-12 goscroll"
          data-anitype="animate__fadeInLeft"
        >
          <div class="img">
            <img
              src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/img_phone_sc_6_80.png"
              alt=""
              width="auto"
              height="auto"
            />
          </div>
        </div>
        <div
          class="col-md-6 col-xs-12 goscroll"
          data-anitype="animate__fadeInRight"
        >
          <h2 class="section-title">
            Trải nghiệm Dịch vụ Chăm sóc Khách hàng
            <span>kiểu mới</span> trên Hi FPT
          </h2>
          <div class="content">
            Quý khách có thể tải và đăng nhập ứng dụng Hi FPT bằng cách quét QR
            Code tại đây
          </div>
          <div class="download">
            <div class="qr-code">
              <img
                src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/qr-code.png"
                alt=""
                width="auto"
                height="auto"
              />
            </div>
          </div>
          <div class="security">
            <p>Phương thức bảo mật sử dụng để đăng nhập Hi FPT</p>
            <div class="security-method">
              <div class="item">
                <div class="icon">
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/icon-touchid.svg"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </div>
                <div class="text">
                  <div class="name">Touch ID</div>
                  <div class="des">Vân tay</div>
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/icon-faceid.svg"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </div>
                <div class="text">
                  <div class="name">Face ID</div>
                  <div class="des">Khuôn mặt</div>
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/icon-passcode.svg"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </div>
                <div class="text">
                  <div class="name">Passcode</div>
                  <div class="des">Mật mã</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <footer id="footer">
    <div class="main-footer">
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-xs-12">
            <div class="footer-title">VỀ CHÚNG TÔI</div>
            <div class="about">
              <div class="item">
                <div class="title">Tên công ty</div>
                <div class="content">Công ty Cổ phần Viễn thông FPT</div>
              </div>
              <div class="item">
                <div class="title">Người đại diện</div>
                <div class="content">Ông Hoàng Việt Anh</div>
              </div>
              <div class="item">
                <div class="title">Địa chỉ</div>
                <div class="content">
                  Tầng 9, Block A, tòa nhà FPT Cầu Giấy, số 10 Phạm Văn Bạch,
                  quận Cầu Giấy, TP. Hà Nội
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-xs-12">
            <div class="footer-title">LIÊN HỆ</div>
            <div class="contact">
              <div class="item">
                <div class="title">Điện thoại hỗ trợ</div>
                <div class="content">024 7300 2222</div>
              </div>
              <div class="item">
                <div class="title">Email</div>
                <div class="content">hifpt@fpt.com</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copy-right">
      <div class="container">
        <div>
          Giấy chứng nhận ĐKDN số 0101778163 do Sở Kế hoạch và Đầu tư Thành
          phố Hà Nội cấp lần đầu ngày 28/07/2005
        </div>
        <div>
          Giấy phép cung cấp dịch vụ viễn thông số 255/GP-CVT do Cục Viễn Thông cấp ngày 07/11/2022
        </div>
      </div>
    </div>
  </footer>
</div>
